import React from 'react'
import Link from 'gatsby-link'
import './footer.scss'

let date = new Date()
const CurrentYear = date.getFullYear()

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-container">
        <div>
          <Link to="/acknowledge">Acknowledgement</Link>
        </div>
        <div>
          <span>HCV.APP, {CurrentYear}</span>
        </div>
        <div>
          <a
            className="license"
            rel="license"
            href="http://creativecommons.org/licenses/by-nc-sa/4.0/"
          >
            <img
              alt="Creative Commons License"
              src="https://i.creativecommons.org/l/by-nc-sa/4.0/80x15.png"
            />
          </a>
        </div>
      </div>
    </div>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/footer.js